import { render, staticRenderFns } from "./UILoading.vue?vue&type=template&id=29f9c0bb&scoped=true&"
import script from "./UILoading.vue?vue&type=script&lang=js&"
export * from "./UILoading.vue?vue&type=script&lang=js&"
import style0 from "./UILoading.vue?vue&type=style&index=0&id=29f9c0bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f9c0bb",
  null
  
)

export default component.exports